// extracted by mini-css-extract-plugin
export default {"p_tye":"c777d07c24","slcted":"f7d7393b40","slc_color":"adeb4700d6","item_p":"_9a38108506","r0":"e231ad67a0"};